import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { MorePartsDataResponse, MorePartsPageControllerImpl } from "../../../business";
import { MorePartsPageFactoryImpl } from "../factories";

export function MorePartsPage() {
  const [isLoading, setLoading] = useState(true);
  const [morePartsData, setMorePartsData] = useState<MorePartsDataResponse>();

  const controller = new MorePartsPageControllerImpl();
  const factory = new MorePartsPageFactoryImpl();

  const fetchData = async () => {
    try {
      const response = await controller.onLoad();
      setLoading(false);

      setMorePartsData(response);
    } catch (error) {
      console.error("Erro na requisição:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return isLoading ? <Spinner animation="border" variant="primary" /> : factory.create(morePartsData);
}
